import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { BankInformationPage } from "@/modules/settings";
import { requireAuth } from "@/utils";

export const Route = createFileRoute("/settings/bank-information/")({
  beforeLoad: requireAuth,
  component: () => (
    <>
      <DocumentTitle
        title="Bank Information"
        description="Manage your bank account information for receiving payments."
      />
      <BankInformationPage />
    </>
  )
});
